export default "__VITE_ASSET__DNpYcjiA__"